import MDTypography from "components/MDTypography";
import { CheckPermissionRender, checkPermission } from "../../../helpers/checkPermission";
import permissions from "../../../config/permissions";
import formatCurrency from "../../../helpers/formatCurrency";

export default function chargesData(records, onDelete, type) {
  const columns = [
    { Header: "From (Units)", accessor: "from", align: "left", minWidth: "70px" },
    { Header: "To (Units)", accessor: "to", align: "left", minWidth: "70px" },
    { Header: "Price", accessor: "price", align: "left" },
    ...(checkPermission(permissions().orgConfig().update().list())
      ? [{ Header: "actions", accessor: "actions", align: "center" }]
      : []),
  ];

  return {
    columns: columns,
    rows: records.map((record, index) => {
      return {
        from: (
          <MDTypography component="a" href="#" variant="caption" color="text" fontWeight="medium">
            {record.units_from}
          </MDTypography>
        ),
        to: (
          <MDTypography component="a" href="#" variant="caption" color="text" fontWeight="medium">
            {records[index + 1]?.units_from - 1 || "--"}
          </MDTypography>
        ),
        price: (
          <MDTypography component="a" href="#" variant="caption" color="text" fontWeight="medium">
            {formatCurrency(record.price)}
          </MDTypography>
        ),
        actions: (
          <>
            {index == records.length - 1 && (
              <CheckPermissionRender permissions={permissions().orgConfig().update().list()}>
                <MDTypography
                  onClick={() => onDelete(type)}
                  component="a"
                  href="#"
                  variant="caption"
                  color="text"
                  fontWeight="medium"
                >
                  Delete
                </MDTypography>
              </CheckPermissionRender>
            )}
          </>
        ),
      };
    }),
  };
}
